import { logoUrl } from "@/lib/brand";

const hex = (r, g, b) => "#" + [r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("");
const sat = (r, g, b) => { const mx = Math.max(r, g, b), mn = Math.min(r, g, b); return mx === 0 ? 0 : (mx - mn) / mx; };
const lum = (r, g, b) => (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
const blend = (c, bg, pct) => hex(c[0] * pct + bg[0] * (1 - pct), c[1] * pct + bg[1] * (1 - pct), c[2] * pct + bg[2] * (1 - pct));

export const paletteFromLogo = (logoKey) => new Promise((resolve, reject) => {
  const url = logoUrl(logoKey);
  if (!url) return reject(new Error("Upload a logo under Branding first"));
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => {
    const c = document.createElement("canvas"); const S = 64; c.width = S; c.height = S;
    const ctx = c.getContext("2d"); ctx.drawImage(img, 0, 0, S, S);
    const { data } = ctx.getImageData(0, 0, S, S);
    const buckets = new Map();
    let dark = 0, light = 0;
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 128) continue;
      const r = data[i], g = data[i + 1], b = data[i + 2], l = lum(r, g, b);
      if (l < 0.18) dark++; else if (l > 0.9) light++;
      if (sat(r, g, b) < 0.35 || l < 0.12 || l > 0.92) continue;
      const k = `${r >> 4},${g >> 4},${b >> 4}`;
      const e = buckets.get(k) || { n: 0, r: 0, g: 0, b: 0 };
      e.n++; e.r += r; e.g += g; e.b += b; buckets.set(k, e);
    }
    const top = [...buckets.values()].sort((a, b) => b.n - a.n)[0];
    if (!top) return reject(new Error("Couldn't find a strong colour in your logo — pick one manually"));
    const acc = [top.r / top.n, top.g / top.n, top.b / top.n];
    const darkBase = light <= dark;
    const bgC = darkBase ? [10, 10, 10] : [250, 250, 250];
    const surfC = darkBase ? [20, 20, 20] : [255, 255, 255];
    resolve({
      accent: hex(...acc),
      bg: blend(acc, bgC, darkBase ? 0.06 : 0.04),
      surface: blend(acc, surfC, darkBase ? 0.1 : 0.02),
      nav: blend(acc, surfC, darkBase ? 0.14 : 0.03),
      ink: darkBase ? "#ffffff" : "#17171a",
      ink2: darkBase ? "#a3a3a3" : "#6b6b72",
    });
  };
  img.onerror = () => reject(new Error("Couldn't read the logo image"));
  img.src = url;
});
